import dayjs from 'dayjs';

/** Date as "10/03/2026", the shape the payment history table prints; empty when unreadable. */
export const getShortDateLabel = (date: string): string => {
  const parsed = dayjs(date);
  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : '';
};
